import {
  EngineOutgoingMessage,
  EngineOutgoingMessagePayload,
  EngineOutgoingMessageType,
} from "@bennara/shared";

const stringifyMessage = (message: EngineOutgoingMessage): string => {
  return JSON.stringify(message);
};

export const createErrorMessage = (message: string): string => {
  return stringifyMessage({
    type: EngineOutgoingMessageType.ERROR,
    payload: {
      message,
    },
  });
};

export const createEngineReadyMessage = (): string => {
  return stringifyMessage({
    type: EngineOutgoingMessageType.ENGINE_READY,
    payload: {},
  });
};

export const createLogMessage = (message: string): string => {
  return stringifyMessage({
    type: EngineOutgoingMessageType.LOG,
    payload: {
      message,
    },
  });
};

export const createTapOnPointMessage = ({
  pointId,
  location,
}: EngineOutgoingMessagePayload[EngineOutgoingMessageType.TAP_ON_POINT]): string => {
  return stringifyMessage({
    type: EngineOutgoingMessageType.TAP_ON_POINT,
    payload: {
      pointId,
      location,
    },
  });
};

export const createTapOnBodyMessage = ({
  location,
}: EngineOutgoingMessagePayload[EngineOutgoingMessageType.TAP_ON_BODY]): string => {
  return stringifyMessage({
    type: EngineOutgoingMessageType.TAP_ON_BODY,
    payload: {
      location,
    },
  });
};

export const createDoubleTapOnBodyMessage = (): string => {
  return stringifyMessage({
    type: EngineOutgoingMessageType.DOUBLE_TAP_ON_BODY,
    payload: {},
  });
};

export const createTapOutsideMessage = ({
  coordinates,
}: EngineOutgoingMessagePayload[EngineOutgoingMessageType.TAP_OUTSIDE]): string => {
  return stringifyMessage({
    type: EngineOutgoingMessageType.TAP_OUTSIDE,
    payload: {
      coordinates,
    },
  });
};
